document.addEventListener("turbo:load", function () {
  $(document).on("click submit", "[data-confirm]", function (e) {
    let $elem = $(e.currentTarget);
    let message = $elem.data("confirm");
    let method = $elem.data("method");
    console.log(method);

    let $content = $(
      "<div style='max-width:350px'><p>" + message + " </p></div>"
    );
    let $buttons = $("<div class='buttons'></div>").appendTo($content);

    var $confirmBtn;
    if (method == "delete") {
      $confirmBtn = $(
        "<form action=" +
          $elem.attr("href") +
          " method=" +
          method +
          "><button class='ok-button'>Confirm</button></form>"
      ).appendTo($buttons);
    } else {
      $confirmBtn = $("<button class='ok-button'>Confirm</button>").appendTo(
        $buttons
      );
    }

    let $cancelBtn = $(
      "<button class='cancel-button'>Cancel</button>"
    ).appendTo($buttons);

    $confirmBtn.click(function () {
      // If we're deleting, just let the normal action run.
      if (method != "delete") {
        $elem.attr("data-confirm", null);

        if (e.type == "click") {
          $(e.target).click();
        } else {
          $(e.target).submit();
        }
        $elem.attr("data-confirm", message);
      }

      MicroModal.close("legacy-micromodal");
    });
    $cancelBtn.click(function () {
      MicroModal.close("legacy-micromodal");
    });

    document.getElementById("legacy-micromodal").classList.add(`theme-light`);
    document.getElementById("c-legacy-modal--header").style.display = "none";
    document.getElementById("legacy-micromodal").classList.remove("naked");
    $("#legacy_modal").html($content);
    MicroModal.show("legacy-micromodal", { disableScroll: true });

    return false;
  });
});
